<template>
    <section class="assigned-reviews" aria-labelledby="assigned-reviews-title">
        <header>
            <h2 id="assigned-reviews-title">Assigned reviews</h2>
            <a v-if="showMapLink" href="/inspection-campaigns/"
                >Open campaign map</a
            >
        </header>
        <p v-if="loading" role="status">Load assigned reviews…</p>
        <p v-else-if="error" role="alert">
            {{ error }} <button type="button" @click="load">Retry</button>
        </p>
        <p v-else-if="!campaigns.length">
            You have no assigned reviews. A campaign manager can assign you.
        </p>
        <ul v-else>
            <li v-for="campaign in campaigns" :key="campaign.uuid">
                <div>
                    <strong>{{ campaign.name }}</strong>
                    <p v-if="campaign.evidence_error" role="status">{{ campaign.evidence_error }}</p>
                    <p v-else-if="campaign.summary_pending">
                        {{ campaign.site }} · {{ campaign.total }} review items.
                        Open the campaign to check current status.
                    </p>
                    <p v-else>
                        {{ campaign.site }} · {{ campaign.counts.reviewed }}/{{
                            campaign.total
                        }}
                        complete<span v-if="campaign.counts.cannot_assess">
                            · {{ campaign.counts.cannot_assess }} cannot
                            assess</span
                        >
                    </p>
                </div>
                <a
                    v-if="!campaign.summary_pending && campaign.next_review_url"
                    :href="campaign.next_review_url"
                    >{{
                        campaign.counts.unreviewed +
                        campaign.counts.needs_review
                            ? 'Continue review'
                            : campaign.counts.cannot_assess
                              ? 'Review exceptions'
                              : 'View assessments'
                    }}</a
                >
                <a
                    v-else
                    :href="`/inspection-campaigns/?campaign=${campaign.uuid}`"
                    >Open campaign</a
                >
            </li>
        </ul>
    </section>
</template>
<script>
import { campaignApi } from './campaignReview';
export default {
    props: { showMapLink: { type: Boolean, default: true } },
    data: () => ({ campaigns: [], loading: true, error: '' }),
    mounted() {
        this.load();
    },
    methods: {
        async load() {
            this.loading = true;
            this.error = '';
            try {
                this.campaigns = (await campaignApi('?assigned=1')).campaigns;
            } catch (error) {
                this.error = error.message;
            } finally {
                this.loading = false;
            }
        }
    }
};
</script>
<style scoped>
.assigned-reviews {
    margin: 20px;
    padding: 18px;
    border: 1px solid var(--sd-border, #cad3df);
    border-radius: 10px;
    background: var(--sd-surface, #fff);
    color: var(--sd-text, #203449);
}
header,
li {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    flex-wrap: wrap;
}
h2 {
    font-size: 21px;
}
ul {
    list-style: none;
    padding: 0;
}
li {
    padding: 12px 0;
    border-top: 1px solid var(--sd-border, #cad3df);
}
p {
    margin: 6px 0;
}
a {
    color: var(--sd-link, #12619c);
}
a:focus-visible,
button:focus-visible {
    outline: 3px solid #277fba;
    outline-offset: 3px;
}
</style>
